import { DialogContent } from "@mui/material";
import { memo } from "react";
import { ActionsSection } from "./ActionsSection";
import { TitleSection } from "./TitleSection";

interface Props {
  title?: string;
  description?: string;
  onClose: () => void;
  buttons?: React.ReactNode;
  children: JSX.Element;
}

const DialogContainerComponent: React.FC<Props> = ({
  title,
  description,
  onClose,
  buttons,
  children,
}) => {
  return (
    <>
      <TitleSection title={title} description={description} onClose={onClose} />
      <DialogContent dividers={!!buttons}>{children}</DialogContent>
      {buttons && <ActionsSection>{buttons}</ActionsSection>}
    </>
  );
};

export const DialogContainer = memo(DialogContainerComponent);
